import React from "react";

export type AddPictureIconProps = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * Choose between them value
   * @default black
   */
  color?: string;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 17,
    height: 15,
  },
  medium: {
    width: 28,
    height: 24,
  },
  large: {
    width: 56,
    height: 48,
  },
};

export const AddPictureIcon = React.forwardRef<
  SVGSVGElement,
  AddPictureIconProps
>((props, ref) => {
  const { size = "medium", width, height, color = "#BBBABF" } = props;
  const svgSize = width && height ? { width, height } : sizes[size];

  return (
    <svg
      ref={ref}
      width={svgSize.width}
      height={svgSize.height}
      viewBox="0 0 28 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.4876 3.29361H9.57188C9.0539 3.29361 8.63438 3.71313 8.63438 4.23111C8.63438 4.74909 9.0539 5.16861 9.57188 5.16861H24.4876C25.0219 5.16861 25.4251 5.75925 25.4251 6.46236V18.1156L22.2565 14.3656C21.7948 13.8066 21.1069 13.4831 20.3815 13.4843C19.6573 13.4808 18.9706 13.8007 18.5065 14.3562L15.1783 18.3594L11.8033 14.3844C11.338 13.8312 10.6513 13.5113 9.92828 13.5125C9.20171 13.516 8.51501 13.843 8.05328 14.4031L4.72509 18.4625V10.4843C4.72509 10.2358 4.62665 9.99675 4.45087 9.82098C4.27509 9.6452 4.03603 9.54676 3.7876 9.54676C3.26962 9.54676 2.8501 9.96628 2.8501 10.4843V20.7968V21.2093C2.87588 21.3909 2.9169 21.569 2.97197 21.7436V21.8936L3.01885 22.0061C3.0833 22.1749 3.16182 22.3378 3.25322 22.4936L3.36572 22.6717C3.4501 22.7971 3.54385 22.9167 3.64697 23.028L3.7876 23.1686C3.93525 23.3081 4.09933 23.4311 4.2751 23.5343H4.30322C4.71104 23.7874 5.18213 23.921 5.66258 23.9186H24.4126C25.2423 23.9104 26.0227 23.5237 26.5313 22.8686C26.7833 22.5557 26.9778 22.2006 27.1032 21.8186C27.1782 21.562 27.2262 21.2983 27.2438 21.0311V20.7405V6.4623C27.3258 4.8369 26.1083 3.4377 24.4876 3.2937L24.4876 3.29361Z"
        fill={color}
      />
      <path
        d="M16.125 9.46249C16.125 10.4984 15.2859 11.3375 14.25 11.3375C13.2141 11.3375 12.375 10.4984 12.375 9.46249C12.375 8.42656 13.2141 7.58749 14.25 7.58749C15.2859 7.58749 16.125 8.42656 16.125 9.46249Z"
        fill={color}
      />
      <path
        d="M3.75 7.99998C3.99844 7.99998 4.2375 7.90154 4.41327 7.72576C4.58905 7.54998 4.68749 7.31092 4.68749 7.06249V5.18749H6.56249C7.08047 5.18749 7.49999 4.76797 7.49999 4.24999C7.49999 3.73201 7.08047 3.31249 6.56249 3.31249H4.68749V1.43749C4.68749 1.18905 4.58905 0.949988 4.41327 0.774218C4.23749 0.598436 3.99843 0.5 3.75 0.5C3.23202 0.5 2.8125 0.91952 2.8125 1.4375V3.3125H0.9375C0.41952 3.3125 0 3.73202 0 4.25C0 4.76798 0.41952 5.1875 0.9375 5.1875H2.8125V7.0625C2.8125 7.31094 2.91094 7.55 3.08672 7.72577C3.2625 7.90155 3.50156 7.99999 3.74999 7.99999L3.75 7.99998Z"
        fill={color}
      />
    </svg>
  );
});

AddPictureIcon.displayName = "AddPictureIcon";
